import { createReducer } from "reduxsauce";

import UIDs from "../../UIDs";

import ReducerRegister from "../ReducerRegister";
import { ActionTypes } from "../actionTypes/layouts/AccountActionTypes";

//
// Actions
//
const Actions = {
    // loadAsync: () => {
    //     return (dispatch /*, getState*/) => {
    //         dispatch({ type: ActionTypes.LOAD_ASYNC });

    //         CompanyService.load(            
    //             response => {
    //                 dispatch(Actions.loadSuccess(response));
    //             },
    //             error => {
    //                 dispatch(Actions.loadFailure(error));
    //             }
    //         );
    //     };
    // },

    // loadSuccess: data => ({
    //     type: ActionTypes.LOAD_SUCCESS,
    //     parentType: ActionTypes.LOAD_ASYNC,
    //     postReducer: loadSuccessPostReducer,
    //     data
    // }),

    // loadFailure: error => ({
    //     type: ActionTypes.LOAD_FAILURE,
    //     parentType: ActionTypes.LOAD_ASYNC,
    //     error
    // })
};

//
// Initial State
//
const INITIAL_STATE = {
    // companyList: []
};

//
// Reducers
//
// const loadSuccessPostReducer = (state, { data }) => {
//     return { ...state, companyList: data };
// };


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    // [ActionTypes.LOAD_ASYNC]: AsyncActionReducers.actionReducer,
    // [ActionTypes.LOAD_SUCCESS]: AsyncActionReducers.successReducer,
    // [ActionTypes.LOAD_FAILURE]: AsyncActionReducers.failureReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.layouts.account, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
